import React from 'react';
import { Loader2 } from 'lucide-react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'ghost' | 'outline';
  size?: 'sm' | 'md' | 'lg';
  isLoading?: boolean;
  fullWidth?: boolean;
}
export function Button({
  children,
  className = '',
  variant = 'primary',
  size = 'md',
  isLoading = false,
  fullWidth = false,
  disabled,
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center font-medium transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed rounded-md';
  const variants = {
    primary: 'bg-cyan-500 hover:bg-cyan-600 text-white shadow-sm focus:ring-cyan-500 border border-transparent',
    secondary: 'bg-gray-900 hover:bg-gray-800 text-white shadow-sm focus:ring-gray-900 border border-transparent',
    ghost: 'text-gray-600 hover:text-gray-900 hover:bg-gray-50 focus:ring-gray-500',
    outline: 'border-2 border-gray-200 bg-white text-gray-700 hover:border-cyan-500 hover:text-cyan-600 focus:ring-cyan-500'
  };
  // Override primary for the specific gradient requirement
  const primaryGradient = variant === 'primary' ? 'bg-gradient-to-r from-cyan-500 to-cyan-600 hover:from-cyan-600 hover:to-cyan-700' : '';
  const sizes = {
    sm: 'px-3 py-1.5 text-sm',
    md: 'px-6 py-3 text-base',
    lg: 'px-8 py-4 text-lg'
  };
  const widthClass = fullWidth ? 'w-full' : '';
  return <button className={`${baseStyles} ${variant === 'primary' ? primaryGradient : variants[variant]} ${sizes[size]} ${widthClass} ${className}`} disabled={disabled || isLoading} {...props} data-id="element-398">
      {isLoading && <Loader2 className="mr-2 h-4 w-4 animate-spin" data-id="element-399" />}
      {children}
    </button>;
}